var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3841 5.78223C16.3221 5.78223 11.3955 10.7088 11.3955 16.7708V22.0637C11.3955 23.1809 10.9193 24.8841 10.3516 25.8364L8.24542 29.3345C6.94511 31.4956 7.84251 33.8947 10.2234 34.7006C18.1169 37.3378 26.633 37.3378 34.5265 34.7006C36.7425 33.968 37.7132 31.349 36.5045 29.3345L34.3983 25.8364C33.8489 24.8841 33.3727 23.1809 33.3727 22.0637V16.7708C33.3727 10.7271 28.4278 5.78223 22.3841 5.78223Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7724 6.31371C25.2047 6.14888 24.6186 6.02068 24.0142 5.94742C22.256 5.72765 20.5711 5.85585 18.9961 6.31371C19.5272 4.95845 20.8458 4.0061 22.3842 4.0061C23.9227 4.0061 25.2413 4.95845 25.7724 6.31371Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8792 35.3604C27.8792 38.3822 25.4068 40.8547 22.3849 40.8547C20.8832 40.8547 19.4913 40.232 18.5023 39.243C17.5133 38.254 16.8906 36.8621 16.8906 35.3604",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.d32e4f011d1eaadea201d6759f6580dd.svg";
export { ForwardRef as ReactComponent };